import React from 'react';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';

export interface InstallChromeExtensionProps {
  text?: string;
  variant?: ButtonVariant;
  className?: string;
  btnClassName?: string;
}

export default function InstallChromeExtension({
  text = 'Install chrome recorder',
  variant = ButtonVariant.Default,
  className,
  btnClassName,
}: InstallChromeExtensionProps) {
  return (
    <a
      href={process.env.CHROME_EXTENSION_URL}
      target='_blank'
      rel='noreferrer'
      className={className}
    >
      <Button className={btnClassName} variant={variant}>
        {text}
      </Button>
    </a>
  );
}
